import CategoryApi from "@shared/_api/category";
import {FETCH_CATEGORY_ALL_SUCCESS} from "../mutationTypes";


const state = {
    customerShopCategoryList: []
};

const getters = {};

const actions = {
    fetchCustomerCategoryList({commit}) {
        return CategoryApi.customerCategoryList().then(categoryList => commit(FETCH_CATEGORY_ALL_SUCCESS, categoryList))
            .catch(error => {
                console.log(error)
            })
    }
};

const mutations = {
    [FETCH_CATEGORY_ALL_SUCCESS](state, categoryList) {
        state.customerShopCategoryList = categoryList;
    }
};

export const category = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};